import * as HLF from "html-living-framework";

export class SceneSpine extends PIXI.Container {
    public z: number = 0;
    protected spine: PIXI.spine.Spine;

    constructor(pSkeleton: string) {
        super();
        this.spine = this.addChild(HLF.PixiUtils.makeSpine(pSkeleton));
        this.spine.state.addListener({
            complete: this.onAnimComplete.bind(this),
        });
    }

    public onLayout() {
        // preserve aspect ratio
        this.scale.set(Math.max(this.scale.x, this.scale.y));
    }

    public update(pDeltaTime: number) {
        this.spine.update(pDeltaTime);
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        if(typeof texture === 'string') {
            texture = texture.replace(/\.png$/, '');
            this.name = texture;
        }
    }

    public playAnimation(pName: string, pLoop: boolean = true, pTrack: number = 0) {
        if (this.spine.state.hasAnimation(pName + "-stepped")) {
            return this.spine.state.setAnimation(pTrack, pName + "-stepped", pLoop);
        }
        if (this.spine.state.hasAnimation(pName)) {
            return this.spine.state.setAnimation(pTrack, pName, pLoop);
        }
        else {
            console.error(this.name + " no such animation: " + pName + " or " + pName + "-stepped");
        }
    }

    private onAnimComplete(pTrack: PIXI.spine.core.TrackEntry): void {
        // if (pTrack.trackIndex === 0) {
        //     switch (pTrack.animation.name) {
        //         break;
        //     }
        // }
    }
}